// extracted by mini-css-extract-plugin
export default {"root":"Header--root--bcf56","container":"Header--container--1Ckaa","header":"Header--header--1v3D6"};